import type { DateRange } from '@/utils';

import { isRecord } from '../guards';

export function isDateRange(value: unknown): value is DateRange {
  return (
    Array.isArray(value) &&
    value.length === 2 &&
    value.every(
      (item) =>
        isRecord(item) &&
        typeof item.month === 'number' &&
        Number.isFinite(item.month) &&
        typeof item.year === 'number' &&
        Number.isFinite(item.year)
    )
  );
}
